<div class="inner">
  <app-project-list></app-project-list>
</div>
